// TGRM Nav v5 — slide-in drawer (mobile-style menu on desktop)
function tgrmInitNav() {
  var navUl = document.querySelector('.t4s-nav__ul');
  if (!navUl || document.getElementById('tgrm-shop-btn')) return;
  var navCol = navUl.parentElement;
  if (!navCol) return;

  navCol.style.cssText = 'display:flex!important;align-items:center;flex:1;min-width:0';

  var btnWrap = document.createElement('div');
  btnWrap.style.cssText = 'flex-shrink:0;margin-right:24px';
  btnWrap.innerHTML = '<button id="tgrm-shop-btn" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg> Shop Our Range</button>';
  navCol.insertBefore(btnWrap, navUl);

  var s = document.createElement('style');
  s.textContent = '#tgrm-shop-btn{display:inline-flex;align-items:center;gap:6px;background:#3a8548;color:#fff!important;padding:10px 18px;border-radius:4px;font-weight:700;font-size:14px;cursor:pointer;border:none;white-space:nowrap;line-height:1;font-family:inherit}#tgrm-shop-btn:hover{background:#2d6e3a}';
  document.head.appendChild(s);

  var megaNav = document.getElementById('tgrm-mega-nav');
  if (!megaNav) return;
  // Move the drawer to <body> so its fixed positioning is never clipped by header stacking/overflow.
  if (megaNav.parentElement !== document.body) document.body.appendChild(megaNav);

  var backdrop = megaNav.querySelector('.tgrm-mega-nav__backdrop');
  var btn = document.getElementById('tgrm-shop-btn');
  var isOpen = false;

  function openNav() { megaNav.classList.add('is-open'); btn.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; isOpen = true; }
  function closeNav() { megaNav.classList.remove('is-open'); btn.classList.remove('is-open'); document.documentElement.style.overflow = ''; isOpen = false; }

  btn.addEventListener('click', function(e) { e.stopPropagation(); isOpen ? closeNav() : openNav(); });
  if (backdrop) backdrop.addEventListener('click', closeNav);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeNav(); });
  // expose close so the snippet's own close button can call it if needed
  megaNav.tgrmClose = closeNav;
}

// Run immediately, on DOMContentLoaded, and on load - whichever fires first
if (document.querySelector('.t4s-nav__ul')) {
  tgrmInitNav();
} else {
  document.addEventListener('DOMContentLoaded', tgrmInitNav);
  window.addEventListener('load', tgrmInitNav);
}


/* ============================================================
   TGRM Cart Fulfilment Chooser + Checkout Gate  (PERMANENT)
   Lives in this always-loaded asset (referenced by layout/theme.liquid)
   so it survives theme copies and Customizer edits — unlike the old
   cart.json custom-liquid section, which kept getting wiped.
   Renders in BOTH the cart drawer AND the cart page, inserting itself
   directly after each ".t4s-cart__tax" line, and BLOCKS the Check Out
   button until the customer has chosen Click & Collect or Delivery.
   Writes a "Fulfilment preference" cart attribute so staff can see
   intent on the order.
   Threshold: 17500 = $175.00. Fee under threshold: flat $10.
   TGRM 2026-09-28: Delivery is now pre-selected by default when the
   customer has no stored preference (Jason's request) — a saved choice
   on the cart still wins, and the customer can switch to Click & Collect.
   The checkout gate therefore only fires in the rare no-choice states.
   ============================================================ */
(function () {
  try {
    var THRESH = 17500;
    var ATTR   = 'Fulfilment preference';
    var VAL_C  = 'Click & Collect — Gympie';
    var VAL_D  = 'Delivery';
    var lastTotal = 0, choice = '', saving = false, styled = false;

    var CSS = `.tgrm-ccp{--ccp-a:#1a6b5a;--ccp-b:#7aad3a;--ccp-track:#e2ece2;max-width:440px;margin:14px 0 6px auto;text-align:left;}
.tgrm-ccp__hazard{display:flex;align-items:flex-start;gap:10px;padding:11px 13px;border-radius:10px;margin-bottom:12px;background:#fff8e1;border:1px solid #f0b400;border-left:5px solid #f0b400;color:#6b4e00;font-size:13px;line-height:1.45;}
.tgrm-ccp__hazard-ico{font-size:20px;line-height:1.15;flex-shrink:0;}
.tgrm-ccp__hazard-txt strong{display:block;font-size:13.5px;font-weight:800;margin-bottom:2px;color:#7a4f00;}
.tgrm-ccp__hazard-txt u{text-decoration:underline;}
.tgrm-ccp__hazard-txt b{color:#7a4f00;}
.tgrm-ccp__choose{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:10px;}
.tgrm-ccp__opt{display:flex;flex-direction:column;align-items:center;gap:2px;padding:10px 8px;border:1px solid #cfe3d2;border-radius:10px;background:#fff;cursor:pointer;font:inherit;color:#20361f;transition:border-color .18s ease,background .18s ease,box-shadow .18s ease;}
.tgrm-ccp__opt:hover{border-color:var(--ccp-a);}
.tgrm-ccp__opt[aria-pressed="true"]{background:var(--ccp-a);border-color:var(--ccp-a);color:#fff;box-shadow:0 2px 8px rgba(26,107,90,.25);}
.tgrm-ccp__opt-ico{font-size:18px;line-height:1;}
.tgrm-ccp__opt-t{font-size:13px;font-weight:700;}
.tgrm-ccp__opt-s{font-size:11px;opacity:.75;}
.tgrm-ccp__gate{display:flex;align-items:flex-start;gap:8px;margin:0 0 10px;padding:9px 12px;border-radius:9px;background:#fff3f2;border:1px solid #e28f88;border-left:4px solid #d9534f;color:#8a2b25;font-size:12.5px;font-weight:700;line-height:1.4;}
.tgrm-ccp__gate-ico{font-size:15px;line-height:1.2;flex-shrink:0;}
.tgrm-ccp.is--gate .tgrm-ccp__choose{animation:tgrmCcpShake .5s ease;}
@keyframes tgrmCcpShake{10%,90%{transform:translateX(-1px);}20%,80%{transform:translateX(2px);}30%,50%,70%{transform:translateX(-4px);}40%,60%{transform:translateX(4px);}}
.tgrm-ccp__inner{border:1px solid #cfe3d2;background:linear-gradient(180deg,#f5fbf4,#eef7ec);border-radius:12px;padding:12px 14px;box-shadow:0 0 0 0 rgba(26,107,90,.35);}
.tgrm-ccp__inner--plain{background:#f7f9f7;border-color:#dfe6df;}
.tgrm-ccp.is--active .tgrm-ccp__inner:not(.tgrm-ccp__inner--plain){animation:tgrmCcpPulse 2.2s ease-in-out infinite;}
.tgrm-ccp.is--unlocked .tgrm-ccp__inner:not(.tgrm-ccp__inner--plain){border-color:#5a9e2f;background:linear-gradient(180deg,#eaf8ea,#dff3df);animation:none;}
.tgrm-ccp__msg{font-size:14px;line-height:1.4;color:#20361f;font-weight:600;}
.tgrm-ccp__msg b{color:var(--ccp-a);font-weight:800;}
.tgrm-ccp__amt{color:var(--ccp-a);font-weight:800;}
.tgrm-ccp__track{margin:9px 0 6px;height:8px;border-radius:99px;background:var(--ccp-track);overflow:hidden;}
.tgrm-ccp__fill{display:block;height:100%;width:0;border-radius:99px;background:linear-gradient(90deg,var(--ccp-b),var(--ccp-a));transition:width .5s ease;}
.tgrm-ccp__sub{font-size:12px;color:#5c6b5a;margin-top:4px;line-height:1.45;}
.tgrm-ccp__note{display:block;margin-top:6px;font-size:12px;font-weight:700;color:var(--ccp-a);}
.tgrm-ccp__prompt{font-size:12.5px;font-weight:700;color:#20361f;margin:2px 0 6px;}
.tgrm-ccp__prompt span{font-weight:600;color:#7a7a7a;}
.tgrm-ccp__guide{display:flex;align-items:flex-start;gap:6px;font-size:12px;line-height:1.5;color:#6b6b6b;background:#f4f4f4;border:1px dashed #cfcfcf;border-radius:8px;padding:8px 11px;margin:2px 0 10px;}
.tgrm-ccp__guide-ico{font-size:14px;line-height:1.3;flex-shrink:0;color:#8a8a8a;}
.tgrm-ccp__guide u{text-decoration:underline;}
.tgrm-ccp__guide b{color:#20361f;font-weight:700;}
@keyframes tgrmCcpPulse{0%{box-shadow:0 0 0 0 rgba(26,107,90,.30);}70%{box-shadow:0 0 0 9px rgba(26,107,90,0);}100%{box-shadow:0 0 0 0 rgba(26,107,90,0);}}
@media (prefers-reduced-motion:reduce){.tgrm-ccp.is--active .tgrm-ccp__inner{animation:none;}.tgrm-ccp.is--gate .tgrm-ccp__choose{animation:none;}}
@media (max-width:600px){.tgrm-ccp{max-width:none;margin-left:0;}}`;

    var HTML = `<div class="tgrm-ccp" role="region" aria-label="Delivery or collection">
  <div class="tgrm-ccp__prompt">How would you like your order?</div>
  <div class="tgrm-ccp__choose">
    <button type="button" class="tgrm-ccp__opt" data-ccp-choose="collect" aria-pressed="false"><span class="tgrm-ccp__opt-ico" aria-hidden="true">&#127978;</span><span class="tgrm-ccp__opt-t">Click &amp; Collect</span><span class="tgrm-ccp__opt-s">Gympie store</span></button>
    <button type="button" class="tgrm-ccp__opt" data-ccp-choose="delivery" aria-pressed="false"><span class="tgrm-ccp__opt-ico" aria-hidden="true">&#128666;</span><span class="tgrm-ccp__opt-t">Delivery</span><span class="tgrm-ccp__opt-s">Australia&#8209;wide</span></button>
  </div>
  <div class="tgrm-ccp__gate" data-ccp-gate hidden><span class="tgrm-ccp__gate-ico" aria-hidden="true">&#9888;</span><span>Please choose <b>Click &amp; Collect</b> or <b>Delivery</b> above before you check out.</span></div>
  <div class="tgrm-ccp__panel" data-ccp-panel-collect hidden><div class="tgrm-ccp__inner"><div class="tgrm-ccp__msg" data-ccp-msg></div><div class="tgrm-ccp__track"><span class="tgrm-ccp__fill" data-ccp-fill></span></div><div class="tgrm-ccp__sub" data-ccp-sub></div></div></div>
  <div class="tgrm-ccp__panel" data-ccp-panel-delivery hidden><div class="tgrm-ccp__inner tgrm-ccp__inner--plain"><div class="tgrm-ccp__msg">Delivered Australia&#8209;wide</div><div class="tgrm-ccp__sub">Freight is calculated at checkout once you enter your address. Bulky, pallet and oversized items are quoted at cost &mdash; we&rsquo;ll confirm before dispatch.<span class="tgrm-ccp__note">Select a Delivery / Shipping method at checkout &mdash; not Click &amp; Collect.</span></div></div></div>
</div>`;

    function money(c){ return '$' + (Math.abs(c)/100).toFixed(2); }

    function injectCSS(){
      if (styled || document.getElementById('tgrm-ccp-css')) { styled = true; return; }
      styled = true;
      var st = document.createElement('style');
      st.id = 'tgrm-ccp-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }

    function paint(el, total){
      var msg  = el.querySelector('[data-ccp-msg]'),
          sub  = el.querySelector('[data-ccp-sub]'),
          fill = el.querySelector('[data-ccp-fill]'),
          gate = el.querySelector('[data-ccp-gate]'),
          pC   = el.querySelector('[data-ccp-panel-collect]'),
          pD   = el.querySelector('[data-ccp-panel-delivery]'),
          pct  = Math.max(0, Math.min(100, (total / THRESH) * 100));
      el.querySelectorAll('[data-ccp-choose]').forEach(function(b){
        b.setAttribute('aria-pressed', b.getAttribute('data-ccp-choose') === choice ? 'true' : 'false');
      });
      if (choice){ if (gate) gate.hidden = true; el.classList.remove('is--gate'); }
      if (pC) pC.hidden = (choice !== 'collect');
      if (pD) pD.hidden = (choice !== 'delivery');
      if (choice !== 'collect'){ el.classList.remove('is--active', 'is--unlocked'); return; }
      if (fill) fill.style.width = pct.toFixed(1) + '%';
      if (total >= THRESH){
        el.classList.remove('is--active'); el.classList.add('is--unlocked');
        if (msg) msg.innerHTML = '🎉 You’ve unlocked <b>FREE Click &amp; Collect</b>!';
        if (sub) sub.innerHTML = 'Collect at 55 Tozer St, Gympie — ready in ~24 hrs.<span class="tgrm-ccp__note">Choose “Click &amp; Collect” as your shipping method at checkout.</span>';
      } else {
        el.classList.add('is--active'); el.classList.remove('is--unlocked');
        if (msg) msg.innerHTML = 'Add <span class="tgrm-ccp__amt">' + money(THRESH - total) + '</span> more to get <b>FREE Click &amp; Collect</b>';
        if (sub) sub.innerHTML = 'Free in-store pickup at Gympie on orders $175+. Under $175, a flat $10 applies.<span class="tgrm-ccp__note">Choose “Click &amp; Collect” as your shipping method at checkout.</span>';
      }
    }

    function paintAll(total){
      document.querySelectorAll('.tgrm-ccp[data-ccp-live]').forEach(function(el){ paint(el, total); });
    }

    function save(){
      if (saving) return; saving = true;
      var body = { attributes: {} };
      body.attributes[ATTR] = choice === 'collect' ? VAL_C : (choice === 'delivery' ? VAL_D : '');
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      }).then(function(r){ return r.json(); })
        .then(function(c){ if (c && typeof c.total_price === 'number') lastTotal = c.total_price; })
        .catch(function(){})
        .then(function(){ saving = false; paintAll(lastTotal); });
    }

    function wire(el){
      if (el.getAttribute('data-ccp-wired')) return;
      el.setAttribute('data-ccp-wired', '1');
      el.querySelectorAll('[data-ccp-choose]').forEach(function(b){
        b.addEventListener('click', function(){ choice = b.getAttribute('data-ccp-choose'); paintAll(lastTotal); save(); });
      });
    }

    // Insert a chooser after EVERY ".t4s-cart__tax" (drawer + cart page). Returns all live choosers.
    function ensureAll(){
      var taxes = document.querySelectorAll('.t4s-cart__tax');
      if (!taxes.length) return [];
      injectCSS();
      var out = [];
      taxes.forEach(function(tax){
        var el = tax.nextElementSibling;
        if (!el || !el.classList || !el.classList.contains('tgrm-ccp')){
          var d = document.createElement('div');
          d.innerHTML = HTML;
          el = d.firstElementChild;
          el.setAttribute('data-ccp-live', '');
          tax.parentNode.insertBefore(el, tax.nextElementSibling);
        }
        wire(el);
        out.push(el);
      });
      return out;
    }

    function sync(total){ lastTotal = total; ensureAll(); paintAll(total); }

    function refresh(){
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function(r){ return r.json(); })
        .then(function(c){
          if (c && c.attributes && c.attributes[ATTR]){
            var v = c.attributes[ATTR];
            choice = /collect/i.test(v) ? 'collect' : (/delivery/i.test(v) ? 'delivery' : choice);
          }
          // TGRM 2026-09-28: no stored preference -> pre-select Delivery by default
          // (customer can still tap Click & Collect; their choice is then saved).
          if (!choice && c && c.item_count > 0){ choice = 'delivery'; save(); }
          sync(c.total_price);
        })
        .catch(function(){ ensureAll(); paintAll(lastTotal); });
    }

    // ---- Checkout gate --------------------------------------------------
    function isCheckoutCtl(node){ return (node && node.closest) ? node.closest('[name="checkout"], .t4s-btn__checkout') : null; }

    function revealGate(nearBtn){
      var list = document.querySelectorAll('.tgrm-ccp[data-ccp-live]');
      list.forEach(function(c){
        var g = c.querySelector('[data-ccp-gate]'); if (g) g.hidden = false;
        c.classList.remove('is--gate'); void c.offsetWidth; c.classList.add('is--gate');
      });
      var target = null;
      if (nearBtn && nearBtn.closest){
        var scope = nearBtn.closest('form, .t4s-mini_cart, .t4s-mini-cart, #t4s-mini_cart, [class*="mini_cart"], [class*="mini-cart"], .t4s-cart, .cart');
        if (scope) target = scope.querySelector('.tgrm-ccp[data-ccp-live]');
      }
      if (!target) target = list[0];
      if (target){ try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch(e){ try { target.scrollIntoView(); } catch(e2){} } }
    }

    function gateInit(){
      if (window.__tgrmCCPgate) return; window.__tgrmCCPgate = true;
      document.addEventListener('click', function(e){
        var ctl = isCheckoutCtl(e.target); if (!ctl) return; if (choice) return;
        e.preventDefault(); e.stopImmediatePropagation();
        ensureAll(); revealGate(ctl); refresh();
      }, true);
      document.addEventListener('submit', function(e){
        var sub = (e.submitter && isCheckoutCtl(e.submitter)); if (!sub) return; if (choice) return;
        e.preventDefault(); e.stopImmediatePropagation();
        ensureAll(); revealGate(sub); refresh();
      }, true);
    }

    function boot(){
      gateInit();
      sync(lastTotal); refresh();
      if (window.fetch && !window.__tgrmCCPf){ window.__tgrmCCPf = window.fetch; window.fetch = function(){
        var a = arguments, p = window.__tgrmCCPf.apply(this, a);
        try { var u = (a[0] && a[0].url) ? a[0].url : ('' + a[0]); if (/\/cart\/(add|change|clear)/i.test(u)) p.then(function(){ setTimeout(refresh, 90); }).catch(function(){}); } catch(e){}
        return p; }; }
      if (window.XMLHttpRequest && !window.__tgrmCCPx){ window.__tgrmCCPx = true;
        var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.open = function(m, u){ this.__tu = u; return xo.apply(this, arguments); };
        XMLHttpRequest.prototype.send = function(){ var s = this; if (s.__tu && /\/cart\/(add|change|update|clear)/i.test(s.__tu)) s.addEventListener('load', function(){ setTimeout(refresh, 90); }); return xs.apply(this, arguments); }; }
      ['cart:updated','cart:refresh','cart:build','cart:change','ajaxProduct:added','on:cart:updated'].forEach(function(ev){ document.addEventListener(ev, function(){ setTimeout(refresh, 90); }); });
      var host = document.body, t;
      try { new MutationObserver(function(){ clearTimeout(t); t = setTimeout(function(){ ensureAll(); paintAll(lastTotal); }, 60); }).observe(host, { childList: true, subtree: true }); } catch(e){}
    }

    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  } catch(e){}
})();
